import React, { useState, useEffect } from 'react';
import Select from 'react-select';
// Importar estilos
import './styles';
// Importar componentes
import Header from './components/Header';
import ValidacionDocumentoAPI from './components/ValidacionDocumentoAPI';
import InformacionPersonal from './components/InformacionPersonal';
import InformacionIglesia from './components/InformacionIglesia';
import InformacionCongreso from './components/InformacionCongreso';
import InformacionPago from './components/InformacionPago';
import AlimentacionCongreso from './components/AlimentacionCongreso';
import Footer from './components/Footer';

function App() {
  const [formData, setFormData] = useState({
    tipoDocumento: '', numeroDocumento: '', nombre: '', apellido: '', email: '', telefono: '', fechaNacimiento: '',
    nombreIglesia: '', pastorIglesia: '', ciudadIglesia: '', denominacion: '',
    tallerPreferencia: '', tallerPreferencia2: '', 
    necesidadesEspeciales: '', comoSeEntero: '', comentarios: '', aceptaTerminos: false,
    // Nuevos campos de pago y alimentación
    comprobantePago: '', metodoPago: 'archivo', menoresEdad: '', nombresMenores: [{ nombre: '', edad: '', neurodivergente: false }], alimentacionCenaViernes: '', 
    alimentacionAlmuerzoSabado: '', alimentacionCenaSabado: '', restriccionesAlimenticias: '',
    // Nuevo campo de autorización de imagen
    autorizaImagen: false
  });

  const [paginaActual, setPaginaActual] = useState(1);
  const [submitMessage, setSubmitMessage] = useState('');
  const [mostrarMensajeExito, setMostrarMensajeExito] = useState(false);
  const [nombreArchivo, setNombreArchivo] = useState('');
  const [mensajeValidacion, setMensajeValidacion] = useState('');
  const [mostrarMensajeValidacion, setMostrarMensajeValidacion] = useState(false);
  const [formularioEnviado, setFormularioEnviado] = useState(false);
  const [documentoValidado, setDocumentoValidado] = useState(false);
  const [documentoExistente, setDocumentoExistente] = useState(false);
  const [comprobanteExistente, setComprobanteExistente] = useState(''); // Nuevo estado para comprobante existente
  const [enviandoFormulario, setEnviandoFormulario] = useState(false); // Nuevo estado para carga del formulario

  // Función de validación por página
  const validarPagina = (pagina) => {
    setMostrarMensajeValidacion(false);
    
    switch(pagina) {
      case 1:
        if (!formData.aceptaTerminos) {
          setMensajeValidacion('Debes aceptar los términos y condiciones para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        return true;
        
      case 2:
        // Validar campos obligatorios
        if (!formData.nombre) {
          setMensajeValidacion('Debes diligenciar tu nombre para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        if (!formData.apellido) {
          setMensajeValidacion('Debes diligenciar tu apellido para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        if (!formData.email) {
          setMensajeValidacion('Debes diligenciar tu correo electrónico para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        
        // Validar formato de email inmediatamente después de confirmar que no está vacío
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
          setMensajeValidacion('Por favor, ingresa un correo electrónico válido');
          setMostrarMensajeValidacion(true);
          return false;
        }
        
        if (!formData.telefono) {
          setMensajeValidacion('Debes diligenciar tu celular para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        
        // Validar que el celular contenga solo números
        const telefonoRegex = /^[0-9]+$/;
        if (!telefonoRegex.test(formData.telefono)) {
          setMensajeValidacion('Por favor, ingresa solo números en el campo celular');
          setMostrarMensajeValidacion(true);
          return false;
        }
        
        // Validar que el celular tenga al menos 10 dígitos
        if (formData.telefono.length < 10) {
          setMensajeValidacion('Por favor, ingresa un número de celular válido (mínimo 10 dígitos)');
          setMostrarMensajeValidacion(true);
          return false;
        }
        if (!formData.fechaNacimiento) {
          setMensajeValidacion('Debes diligenciar tu fecha de nacimiento para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        
        // Validar que la persona tenga al menos 10 años
        const fechaNacimiento = new Date(formData.fechaNacimiento);
        const fechaActual = new Date();
        const edad = fechaActual.getFullYear() - fechaNacimiento.getFullYear();
        const mesActual = fechaActual.getMonth();
        const diaActual = fechaActual.getDate();
        const mesNacimiento = fechaNacimiento.getMonth();
        const diaNacimiento = fechaNacimiento.getDate();
        
        // Ajustar edad si aún no ha cumplido años este año
        let edadReal = edad;
        if (mesActual < mesNacimiento || (mesActual === mesNacimiento && diaActual < diaNacimiento)) {
          edadReal = edad - 1;
        }
        
        if (edadReal < 12) {
          setMensajeValidacion('Debes tener al menos 12 años para participar en el congreso');
          setMostrarMensajeValidacion(true);
          return false;
        }
        
        if (formData.menoresEdad === 'si') {
          const menoresValidos = formData.nombresMenores.every(menor => 
            menor.nombre.trim() !== '' && menor.edad !== ''
          );
          if (!menoresValidos) {
            setMensajeValidacion('Debes diligenciar el nombre y edad de todos los menores');
            setMostrarMensajeValidacion(true);
            return false;
          }
        }
        return true;
        
      case 3:
        if (!formData.nombreIglesia || !formData.pastorIglesia || !formData.ciudadIglesia || !formData.denominacion) {
          setMensajeValidacion('Debes diligenciar toda la información de tu iglesia para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        return true;
        
      case 4:
        if (!formData.tallerPreferencia || !formData.tallerPreferencia2 || !formData.comoSeEntero) {
          setMensajeValidacion('Debes seleccionar los talleres y cómo te enteraste para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        return true;
        
      case 5:
        if (!formData.comprobantePago) {
          setMensajeValidacion('Debes adjuntar el comprobante de pago para continuar');
          setMostrarMensajeValidacion(true);
          return false;
        }
        return true;
        
      default:
        return true;
    }
  };

  // Opciones para los selects
  const denominacionOptions = [
    // Misiones y denominaciones con fuerte presencia local
    { value: 'cuadrangular', label: 'Iglesia Cristiana Cuadrangular' },
    { value: 'misionero_mundial', label: 'Movimiento Misionero Mundial' },
    { value: 'sos_iglesia_cristiana', label: 'S.O.S Iglesia Cristiana' },

    // Iglesias locales específicas de Medellín con trayectoria
    { value: 'verdad_y_vida', label: 'Ministerio Verdad y Vida' },
    { value: 'avivamiento', label: 'Iglesia Avivamiento' },
    { value: 'cristiana_triunfante', label: 'Iglesia Cristiana Triunfante' },
    { value: 'global_restauracion', label: 'Iglesia Global de Restauración' },
    { value: 'redil', label: 'El Redil' },

     // Denominaciones históricas y movimientos amplios
    { value: 'bautista', label: 'Bautista' },
    { value: 'presbiteriana', label: 'Presbiteriana' },
    { value: 'pentecostal_carismatica', label: 'Pentecostal / Carismática' },

    // Otra opción adicional que apareció en la búsqueda
    { value: 'comunidad_mde', label: 'Comunidad MDE' },

    // Otras opciones
    { value: 'catolica', label: 'Católica' },
    { value: 'otra', label: 'Otra' },
  ];

  const taller1Options = [
   // { value: 'decisiones-sabias', label: 'Decisiones sabias' },
    { value: 'dependencia-emocional', label: 'Dependencia Emocional' },
  //  { value: 'adn-familia-cristiana', label: 'ADN de una familia cristiana' },
    { value: 'no-asistir1', label: 'No asistiré a ningún taller en ese horario' }
  ];

  const taller2Options = [
    // { value: 'finanzas', label: 'Finanzas' },
    { value: 'jovenes-dependencia', label: 'Jovenes y la dependencia' },
    { value: 'evangelizar-mundo-relativista', label: '¿Cómo evangelizar en un mundo relativista?' },
    { value: 'no-asistir2', label: 'No asistiré a ningún taller en ese horario' }
  ];

  const comoSeEnteroOptions = [
    { value: 'iglesia', label: 'Mi iglesia' },
    { value: 'redes', label: 'Redes sociales' },
    { value: 'amigo', label: 'Un amigo / familiar' },
    { value: 'pagina', label: 'Página web' },
    { value: 'email', label: 'Email marketing' },
    { value: 'otro', label: 'Otro' },
  ];

// Opciones para el almuerzo del sábado
const almuerzoSabadoOptions = [
    {
        value: 'opcion1_almuerzo',
        label: 'Opción 1: Arroz con pollo y verduras, plátano calado, ensalada, sopa y guarapo - $20.000'
    },
    {
        value: 'opcion2_almuerzo',
        label: 'Opción 2: Frijoles, arroz blanco, carne de cerdo, tajada de maduro, ensalada y guarapo - $20.000'
    },
    { value: 'no_almuerzo', label: 'No requiero almuerzo' }
];

// Opciones para la cena del viernes
const cenaViernesOptions = [
    {
        value: 'opcion1_cena_viernes',
        label: 'Opción 1: Arepa de chócolo con quesito y chocolate - $12.000'
    },
    {
        value: 'opcion2_cena_viernes',
        label: 'Opción 2: Sanduche danés (pan, pollo con verduras, jamón, queso, lechuga, tomate y salsas) con gaseosa - $17.000'
    },
    {
        value: 'opcion3_cena_viernes',
        label: 'Opción 3: Hamburguesa con carne, queso, lechuga, tomate, cebolla, pepinos agridulces y salsas con gaseosa - $17.000'
    },
    { value: 'no_cena_viernes', label: 'No requiero cena' }
];

// Opciones para la cena del sábado
const cenaSabadoOptions = [
    {
        value: 'opcion1_cena_sabado',
        label: 'Opción 1: Arepa de chócolo con quesito y chocolate - $12.000'
    },
    {
        value: 'opcion2_cena_sabado',
        label: 'Opción 2: Sanduche danés (pan, pollo con verduras, jamón, queso, lechuga, tomate y salsas) con gaseosa - $17.000'
    },
    {
        value: 'opcion3_cena_sabado',
        label: 'Opción 3: Hamburguesa con carne, queso, lechuga, tomate, cebolla, pepinos agridulces y salsas con gaseosa - $17.000'
    },
    { value: 'no_cena_sabado', label: 'No requiero cena' }
];

  // Estilos personalizados para React Select
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      width: '100%',
      height: '52px',
      minHeight: '52px',
      border: '1px solid #d1d5db',
      borderRadius: '8px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
      fontSize: '16px',
      lineHeight: '1.4',
      backgroundColor: 'white',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.1)' : 'none',
      borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
      '&:hover': {
        borderColor: '#9ca3af',
      },
      cursor: 'pointer',
      padding: '0 12px',
    }),
    placeholder: (base) => ({
      ...base,
      color: '#9ca3af',
      fontSize: '16px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    }),
    singleValue: (base) => ({
      ...base,
      color: '#1f2937',
      fontSize: '16px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '8px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e5e7eb',
      marginTop: '4px',
    }),
    menuList: (base) => ({
      ...base,
      borderRadius: '8px',
      padding: '4px',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#f3f4f6' : 'white',
      color: '#1f2937',
      padding: '12px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '16px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
      '&:active': {
        backgroundColor: '#e5e7eb',
      },
    }),
  };

  // Función para convertir archivo a base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result;
        // Extraer solo los datos base64 (sin el prefijo)
        const base64Data = result.split(',')[1];
        resolve({
          name: file.name,
          type: file.type,
          data: base64Data
        });
      };
      reader.onerror = error => reject(error);
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else if (type === 'file' && files && files[0]) {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
      setNombreArchivo(files[0].name);
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSelectChange = (selectedOption, fieldName) => {
    // Para campos de alimentación, guardar el label completo; para otros, guardar el value
    const isAlimentacionField = fieldName.includes('alimentacion');
    setFormData(prev => ({ 
      ...prev, 
      [fieldName]: selectedOption ? (isAlimentacionField ? selectedOption.label : selectedOption.value) : '' 
    }));
  };

  // Función para formatear fecha de ISO a YYYY-MM-DD para input type="date"
  const formatearFechaParaInput = (fechaISO) => {
    if (!fechaISO) return '';
    
    try {
      // Si ya está en formato YYYY-MM-DD, devolverla directamente
      if (fechaISO.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return fechaISO;
      }
      
      // Convertir de formato ISO a YYYY-MM-DD
      const fecha = new Date(fechaISO);
      const año = fecha.getFullYear();
      const mes = String(fecha.getMonth() + 1).padStart(2, '0');
      const dia = String(fecha.getDate()).padStart(2, '0');
      
      return `${año}-${mes}-${dia}`;
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return '';
    }
  };

  const handleDocumentoValidado = (existente, datosCargados = null) => {
    setDocumentoValidado(true);
    setDocumentoExistente(existente);
    
    if (existente && datosCargados) {
      // Si el documento existe y hay datos, cargarlos en el formulario
      setFormData(prev => ({
        ...prev,
        // Datos personales
        nombre: datosCargados.nombre || '',
        apellido: datosCargados.apellido || '',
        email: datosCargados.email || '',
        telefono: datosCargados.telefono || '',
        fechaNacimiento: formatearFechaParaInput(datosCargados.fechaNacimiento),
        // Datos iglesia
        nombreIglesia: datosCargados.nombreIglesia || '',
        pastorIglesia: datosCargados.pastorIglesia || '',
        ciudadIglesia: datosCargados.ciudadIglesia || '',
        denominacion: datosCargados.denominacion || '',
        // Datos congreso
        tallerPreferencia: datosCargados.tallerPreferencia || '',
        tallerPreferencia2: datosCargados.tallerPreferencia2 || '',
        necesidadesEspeciales: datosCargados.necesidadesEspeciales || '',
        comoSeEntero: datosCargados.comoSeEntero || '',
        comentarios: datosCargados.comentarios || '',
        // Datos adicionales
        menoresEdad: datosCargados.menoresEdad || '',
        nombresMenores: datosCargados.nombresMenores ? JSON.parse(datosCargados.nombresMenores) : [{ nombre: '', edad: '' }],
        alimentacionCenaViernes: datosCargados.alimentacionCenaViernes || '',
        alimentacionAlmuerzoSabado: datosCargados.alimentacionAlmuerzoSabado || '',
        alimentacionCenaSabado: datosCargados.alimentacionCenaSabado || '',
        restriccionesAlimenticias: datosCargados.restriccionesAlimenticias || '',
        aceptaTerminos: prev.aceptaTerminos || datosCargados.aceptaTerminos === 'TRUE',
        autorizaImagen: prev.autorizaImagen !== undefined ? prev.autorizaImagen : (datosCargados.autorizaImagen === 'TRUE'),
        // Determinar método de pago según el valor guardado
        metodoPago: datosCargados.comprobantePago === 'Efectivo' ? 'efectivo' : 
                   datosCargados.comprobantePago === 'No adjuntado' ? 'archivo' : 'archivo',
        // Cargar comprobante existente si lo hay
        comprobantePago: datosCargados.comprobantePago && datosCargados.comprobantePago !== 'Efectivo' && datosCargados.comprobantePago !== 'No adjuntado' ? datosCargados.comprobantePago : ''
      }));
      
      // Mostrar nombre del archivo si existe comprobante (excluir 'Efectivo')
      if (datosCargados.comprobantePago && 
          datosCargados.comprobantePago !== 'No adjuntado' && 
          datosCargados.comprobantePago !== 'Efectivo') {
        setNombreArchivo('Comprobante existente cargado');
        // Guardar el comprobante existente para usarlo después si no se cambia
        setComprobanteExistente(datosCargados.comprobantePago);
        
              } else {
        setNombreArchivo('');
        setComprobanteExistente('');
        
              }
    }
    
    // Avanzar a la página 2 (Información Personal)
    setPaginaActual(2);
  };

  const irAPagina = (num) => {
    setPaginaActual(num);
  };

  const paginaSiguiente = () => {
    if (paginaActual < 5) {
      if (paginaActual === 1) {
        // Si está en términos, ir a validación de documento
        if (validarPagina(paginaActual)) {
          setPaginaActual(1.5); // Página de validación de documento
        }
      } else if (paginaActual === 1.5) {
        // Si está en validación de documento, debe estar validado para continuar
        if (!documentoValidado) {
          setMensajeValidacion('Debes validar tu documento antes de continuar');
          setMostrarMensajeValidacion(true);
          return;
        }
        setMostrarMensajeValidacion(false); // Limpiar mensaje de validación al continuar
        setPaginaActual(2);
      } else if (validarPagina(paginaActual)) {
        setPaginaActual(paginaActual + 1);
      }
    }
  };

  const paginaAnterior = () => {
    if (paginaActual > 1) {
      setMostrarMensajeValidacion(false); // Limpiar mensaje de validación
      
      if (paginaActual === 2) {
        // Si está en información personal, volver a validación de documento
        setPaginaActual(1.5);
        setDocumentoExistente(false); // Limpiar mensaje de documento encontrado
        setComprobanteExistente(''); // Limpiar comprobante existente
      } else if (paginaActual === 1.5) {
        // Si está en validación de documento, volver a términos
        setPaginaActual(1);
        setDocumentoExistente(false); // Limpiar mensaje de documento encontrado
        setComprobanteExistente(''); // Limpiar comprobante existente
      } else {
        setPaginaActual(paginaActual - 1);
      }
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Capturar el estado actual antes de cualquier modificación
  const estadoActual = { ...formData };
  
  // Iniciar estado de carga
  setEnviandoFormulario(true);
  
  try {

   // ENDER const scriptURL = 'https://script.google.com/macros/s/AKfycbx02P0P22_ZBvc2uZSiRlR7lDBzHjWPJaOiZtGYBH50At7wq5t61xnUtCpweE1sGqne/exec';
    const scriptURL = 'https://script.google.com/macros/s/AKfycbxQ9ROm7k5--S8P7PDSEDLmhI1vj1pc3lgKhcSEBEDE0tYUkybn1bIRAxYc6qfQjtTj/exec';

    // Determinar valor del comprobante según método de pago
    let comprobanteFinal = '';
    if (estadoActual.metodoPago === 'efectivo') {
      comprobanteFinal = 'Efectivo';
    } else if (estadoActual.metodoPago === 'no_adjuntado') {
      comprobanteFinal = 'No adjuntado';
    } else {
      comprobanteFinal = estadoActual.comprobantePago; // URL del Drive o base64
    }

    let datosFormulario = {
      tipoDocumento: estadoActual.tipoDocumento,
      numeroDocumento: estadoActual.numeroDocumento,
      nombre: estadoActual.nombre,
      apellido: estadoActual.apellido,
      email: estadoActual.email,
      telefono: estadoActual.telefono,
      fechaNacimiento: estadoActual.fechaNacimiento,
      nombreIglesia: estadoActual.nombreIglesia,
      pastorIglesia: estadoActual.pastorIglesia,
      ciudadIglesia: estadoActual.ciudadIglesia,
      denominacion: estadoActual.denominacion,
      tallerPreferencia: estadoActual.tallerPreferencia,
      tallerPreferencia2: estadoActual.tallerPreferencia2,
      necesidadesEspeciales: estadoActual.necesidadesEspeciales,
      comoSeEntero: estadoActual.comoSeEntero,
      comentarios: estadoActual.comentarios,
      aceptaTerminos: estadoActual.aceptaTerminos === true ? 'TRUE' : 'FALSE',
      autorizaImagen: estadoActual.autorizaImagen === true ? 'TRUE' : 'FALSE',
      menoresEdad: estadoActual.menoresEdad,
      nombresMenores: estadoActual.nombresMenores,
      alimentacionCenaViernes: estadoActual.alimentacionCenaViernes,
      alimentacionAlmuerzoSabado: estadoActual.alimentacionAlmuerzoSabado,
      alimentacionCenaSabado: estadoActual.alimentacionCenaSabado,
      restriccionesAlimenticias: estadoActual.restriccionesAlimenticias,
      comprobantePago: comprobanteFinal
    };
    // Validar comprobante de pago (opcional)
    // Permitir enviar tanto con comprobante como sin él
    if (formData.comprobantePago && formData.comprobantePago !== '' && formData.comprobantePago instanceof File) {
      // Se adjuntó comprobante de pago válido
    } else if (formData.comprobantePago && formData.comprobantePago !== '') {
      // Comprobante de pago existe pero no es File object
    } else {
      // No se adjuntó comprobante de pago (opcional)
    }

    // Manejar comprobante según método de pago
    if (estadoActual.metodoPago === 'efectivo') {
      // Ya se configuró comprobantePago = 'Efectivo' - no hacer nada más
      delete datosFormulario.nombreArchivo;
          } else if (formData.comprobantePago && formData.comprobantePago instanceof File) {
      // Se adjuntó un nuevo archivo - reemplazar el existente
      const extension = formData.comprobantePago.name.split('.').pop();
      const nombrePersonalizado = `Comprobante_${formData.numeroDocumento}_${formData.nombre}_${formData.apellido}.${extension}`;
      
      const archivoBase64 = await fileToBase64(formData.comprobantePago);
      datosFormulario.comprobantePago = archivoBase64;
      datosFormulario.nombreArchivo = nombrePersonalizado;
      
          } else if (formData.comprobantePago && 
               typeof formData.comprobantePago === 'string' && 
               formData.comprobantePago !== '' && 
               formData.comprobantePago !== 'No adjuntado') {
      // No se adjuntó nuevo archivo pero formData tiene comprobante existente (base64) - mantenerlo
      datosFormulario.comprobantePago = formData.comprobantePago;
      datosFormulario.nombreArchivo = `Comprobante_${formData.numeroDocumento}_${formData.nombre}_${formData.apellido}`;
      
          } else {
      // No hay comprobante nuevo ni existente y no es efectivo
      // Ya se configuró comprobanteFinal = 'No adjuntado' - no hacer nada más
          }

    const response = await fetch(scriptURL, {
      method: 'POST',
      mode: 'no-cors', // Temporal para evitar CORS
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(datosFormulario)
    });

    // Con modo no-cors, asumimos éxito si no hay errores de red
    if (response.type === 'opaque') {
      // Verificar si hay comprobante (nuevo archivo, URL de Drive, o base64)
      const tieneComprobante = formData.comprobantePago && 
                              formData.comprobantePago !== '' && 
                              formData.comprobantePago !== 'No adjuntado' &&
                              (formData.comprobantePago instanceof File || 
                               (typeof formData.comprobantePago === 'string' && 
                                (formData.comprobantePago.startsWith('data:') || 
                                 formData.comprobantePago.startsWith('https://drive.google.com'))));
      
      let mensajeExito = '¡Registro enviado exitosamente!';

      if (!tieneComprobante) {
        mensajeExito += '\n\n\nPor favor recuerda realizar el pago del congreso y enviar el comprobante de pago al numero de WhatsApp 313-805-6230 para completar su inscripción.';
      }
      
      setSubmitMessage(mensajeExito);
      setFormularioEnviado(true);
      setPaginaActual(6);
      return;
    }
    
    // Intentar leer la respuesta
    let responseData;
    try {
      responseData = await response.json();
      
      if (responseData.status === 'success') {
        let mensajeExito = '¡Registro enviado exitosamente!';
        
        // Verificar si se adjuntó comprobante
        const tieneComprobante = formData.comprobantePago && formData.comprobantePago !== '' && formData.comprobantePago instanceof File;
        
        // Agregar información del archivo si está disponible
        if (responseData.fileUrl && responseData.fileUrl !== 'No adjuntado' && !responseData.fileUrl.includes('Error')) {
          mensajeExito += `\n\n📎 Comprobante guardado: ${responseData.fileUrl}`;
        } else if (!tieneComprobante) {
          mensajeExito += '\n\nPor favor recuerda realizar el pago del congreso y enviar el comprobante de pago al numero de WhatsApp 313-805-6230 para completar su inscripción.';
        }
        
        setSubmitMessage(mensajeExito);
        setFormularioEnviado(true);
        setPaginaActual(6);
      } else {
        setSubmitMessage('Error del servidor: ' + responseData.message);
      }
    } catch (parseError) {
      // Si no podemos parsear JSON, asumimos éxito por ahora
      
      // Verificar si hay comprobante (nuevo archivo, URL de Drive, o base64)
      const tieneComprobante = formData.comprobantePago && 
                              formData.comprobantePago !== '' && 
                              formData.comprobantePago !== 'No adjuntado' &&
                              (formData.comprobantePago instanceof File || 
                               (typeof formData.comprobantePago === 'string' && 
                                (formData.comprobantePago.startsWith('data:') || 
                                 formData.comprobantePago.startsWith('https://drive.google.com'))));
      
      let mensajeExito = '¡Registro enviado exitosamente!';
      if (!tieneComprobante) {
        mensajeExito += '\n\nPor favor recuerda realizar el pago del congreso y enviar el comprobante de pago al numero de WhatsApp 313-805-6230 para completar su inscripción.';
      }
      
      setSubmitMessage(mensajeExito);
      setFormularioEnviado(true);
      setPaginaActual(6);
    }

  } catch (error) {
    setSubmitMessage('Error al enviar: ' + error.message);
  } finally {
    // Siempre limpiar el estado de carga
    setEnviandoFormulario(false);
  }
};


  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
      padding: '2rem 1rem'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        border: '1px solid #e5e7eb'
      }}>
        <div style={{ padding: '2rem' }}>
          <Header paginaActual={paginaActual} />
          
          {/* Contenido dinámico según página */}
          <div style={{ flex: 1 }}>
            {paginaActual === 1 && (
              <div>
                <div style={{
                  backgroundColor: '#f0f9ff',
                  border: '1px solid #bfdbfe',
                  borderRadius: '8px',
                  padding: '1rem',
                  marginBottom: '1rem',
                  textAlign: 'justify'
                }}>
                  <p style={{
                    fontSize: '1rem',
                    color: '#3A7D5C',
                    marginBottom: '0.75rem',
                    fontWeight: '500',
                    textAlign: 'justify'
                  }}>
                    Este es el primer paso para la participación de nuestro Congreso 2026 - SU PROVIDENCIA, que tendrá lugar del 15 al 17 de mayo de 2026 en la Iglesia Cristiana Cuadrangular Sabaneta. (Si vienes de otra iglesia informale a tu pastor).
                  </p>
                  <p style={{
                    fontSize: '1rem',
                    color: '#3A7D5C',
                    lineHeight: '1.4',
                    textAlign: 'justify',
                    wordSpacing: '0.05em'
                  }}>
                    Le informamos que conforme a los lineamientos de la ley 1581 de 2012, decreto reglamentario y la política de tratamiento de datos de la Iglesia Cristiana Cuadrangular De Sabaneta garantizaremos la seguridad y confidencialidad respecto del tratamiento de los datos suministrados en el presente documento, igualmente propenderemos por su debida custodia, uso, circulación y supresión.
                  </p>
                  
                  {/* Aceptación de términos */}
                  <div className="terminos-container">
                    <label className="terminos-label">
                      <div className="terminos-toggle">
                        <input
                          type="checkbox"
                          name="aceptaTerminos"
                          checked={formData.aceptaTerminos}
                          onChange={handleChange}
                          style={{ 
                            position: 'absolute',
                            opacity: '0',
                            width: '0',
                            height: '0'
                          }}
                        />
                        <span style={{
                          position: 'absolute',
                          cursor: 'pointer',
                          top: '0',
                          left: '0',
                          right: '0',
                          bottom: '0',
                          backgroundColor: formData.aceptaTerminos ? '#3A7D5C' : '#d1d5db',
                          transition: '0.3s',
                          borderRadius: '24px'
                        }}></span>
                        <span style={{
                          position: 'absolute',
                          content: '""',
                          height: '18px',
                          width: '18px',
                          left: formData.aceptaTerminos ? '26px' : '3px',
                          bottom: '3px',
                          backgroundColor: 'white',
                          transition: '0.3s',
                          borderRadius: '50%'
                        }}></span>
                      </div>
                      <span className="terminos-text">
                        Acepto los términos y condiciones del congreso y autorizo el tratamiento de mis datos personales según la política de privacidad.
                      </span>
                    </label>
                  </div>

                  {/* Autorización de uso de imagen */}
                  <div className="terminos-container" style={{ marginTop: '1rem' }}>
                    <label className="terminos-label">
                      <div className="terminos-toggle">
                        <input
                          type="checkbox"
                          name="autorizaImagen"
                          checked={formData.autorizaImagen}
                          onChange={handleChange}
                          style={{ 
                            position: 'absolute',
                            opacity: '0',
                            width: '0',
                            height: '0'
                          }}
                        />
                        <span style={{
                          position: 'absolute',
                          cursor: 'pointer',
                          top: '0',
                          left: '0',
                          right: '0',
                          bottom: '0',
                          backgroundColor: formData.autorizaImagen ? '#3A7D5C' : '#d1d5db',
                          transition: '0.3s',
                          borderRadius: '24px'
                        }}></span>
                        <span style={{
                          position: 'absolute',
                          content: '""',
                          height: '18px',
                          width: '18px',
                          left: formData.autorizaImagen ? '26px' : '3px',
                          bottom: '3px',
                          backgroundColor: 'white',
                          transition: '0.3s',
                          borderRadius: '50%'
                        }}></span>
                      </div>
                      <span className="terminos-text">
                        Autorizo el uso de mi imagen en fotografías y/o videos tomados durante el congreso, los cuales podrán ser utilizados por la organización para fines informativos, promocionales y de difusión en medios físicos o digitales.
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {paginaActual === 2 && (
              <InformacionPersonal formData={formData} handleChange={handleChange} setFormData={setFormData} />
            )}

            {paginaActual === 1.5 && (
              <ValidacionDocumentoAPI 
                formData={formData} 
                handleChange={handleChange} 
                onDocumentoValidado={handleDocumentoValidado}
                setFormData={setFormData}
                documentoExistente={documentoExistente}
              />
            )}

            {paginaActual === 3 && (
              <InformacionIglesia 
                formData={formData} 
                handleChange={handleChange} 
                denominacionOptions={denominacionOptions} 
              />
            )}

            {paginaActual === 4 && (
              <InformacionCongreso 
                formData={formData} 
                handleSelectChange={handleSelectChange}
                taller1Options={taller1Options}
                taller2Options={taller2Options}
                comoSeEnteroOptions={comoSeEnteroOptions}
                handleChange={handleChange}
              />
            )}

            {paginaActual === 5 && (
              <div>
                <InformacionPago formData={formData} handleChange={handleChange} nombreArchivo={nombreArchivo} />
                
                <div style={{ marginTop: '3rem' }}>
                  <AlimentacionCongreso 
                    formData={formData}
                    handleSelectChange={handleSelectChange}
                    cenaViernesOptions={cenaViernesOptions}
                    almuerzoSabadoOptions={almuerzoSabadoOptions}
                    cenaSabadoOptions={cenaSabadoOptions}
                  />
                </div>
              </div>
            )}
          </div>

          {paginaActual === 6 && (
            <div style={{ 
              textAlign: 'center', 
              padding: '3rem 1rem',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              <div style={{
                fontSize: '3rem',
                color: '#3A7D5C',
                marginBottom: '1rem'
              }}>
                ✅
              </div>
              <h2 style={{
                fontSize: '2rem',
                color: '#1f2937',
                marginBottom: '1.5rem',
                fontWeight: '600'
              }}>
                {submitMessage.includes('exitosamente') ? '¡Registro Completado!' : 'Error en el Registro'}
              </h2>
              <div style={{
                fontSize: '1.125rem',
                lineHeight: '1.6',
                color: '#374151',
                backgroundColor: submitMessage.includes('exitosamente') ? '#f0fdf4' : '#fef2f2',
                border: `1px solid ${submitMessage.includes('exitosamente') ? '#bbf7d0' : '#fecaca'}`,
                borderRadius: '12px',
                padding: '1.5rem',
                marginBottom: '2rem'
              }}>
                {submitMessage}
              </div>
              {submitMessage.includes('exitosamente') && (
                <button
                  onClick={() => window.location.reload()}
                  style={{
                    backgroundColor: '#3A7D5C',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 2rem',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#2d5f47'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#3A7D5C'}
                >
                  Nuevo Registro
                </button>
              )}
            </div>
          )}

          {/* Mensaje de validación - solo mostrar si no está en página 6 */}
          {paginaActual !== 6 && mostrarMensajeValidacion && (
            <div style={{
              marginTop: '1rem',
              padding: '1rem',
              borderRadius: '8px',
              backgroundColor: '#f0fdf4',
              border: '1px solid #bbf7d0',
              color: '#166534',
              fontSize: '0.875rem',
              fontWeight: '500'
            }}>
              {mensajeValidacion}
            </div>
          )}

          {/* Mensaje de éxito/error */}
          {mostrarMensajeExito && (
            <div style={{
              marginTop: '1rem',
              padding: '1rem',
              borderRadius: '8px',
              backgroundColor: submitMessage.includes('exitosamente') ? '#f0fdf4' : '#fef2f2',
              border: `1px solid ${submitMessage.includes('exitosamente') ? '#bbf7d0' : '#fecaca'}`,
              color: submitMessage.includes('exitosamente') ? '#166534' : '#dc2626'
            }}>
              {submitMessage}
            </div>
          )}

          {/* Footer - solo mostrar si no está en página 6 */}
          {paginaActual !== 6 && (
            <Footer 
              paginaActual={paginaActual}
              paginaAnterior={paginaAnterior}
              paginaSiguiente={paginaSiguiente}
              handleSubmit={handleSubmit}
              aceptaTerminos={formData.aceptaTerminos}
              enviandoFormulario={enviandoFormulario}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
